/* eslint-disable no-console */
import { httpModule } from '@shared/http';

export type Concept = {
    id?: number;
    name: string;
    description: string;
    type: 'Service' | 'Base' | 'Tax' | 'ContractExpense' | 'Movement' | 'General';
    visibility: boolean;
};

export async function fetchConcepts(page?: number, limit?: number,  types?: string) {
    try {
        return await httpModule.get('/concepts', {
            params: { page, limit, types }
        });
    } catch (ex) {
        console.warn('Error fetching concepts');
        console.log(ex.response);
    }
}

export async function postConcept(concept: any) {
    try {
        return await httpModule.post('/concepts', concept);
    } catch (ex) {
        console.warn('Error posting concept');
        console.log(ex.response);
    }
}

export async function patchConcept(concept: any) {
    try {
        return await httpModule.patch('/concepts', concept);
    } catch (ex) {
        console.warn('Error updating concept');
        console.log(ex.response);
    }
}

export async function getConcept(id: number) {
    try {
        return await httpModule.get(`/concepts/${id}`);
    } catch (ex) {
        console.warn('Error getting a concept');
        console.log(ex.response);
    }
}

export async function deleteConcept(id: number) {
    try {
        return await httpModule.delete(`/concepts/${id}`);
    } catch (ex) {
        console.warn('Error deleting a concept');
        console.log(ex.response);
    }
}
